














import Restricted from '../auth/Restricted.vue'
export default {
  components: { Restricted }
}
